import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { HealthData } from "@/health/HealthPage";
import { HealthPage } from "@/health/HealthPage";
import { WorkspaceAdminAccessDenied, WorkspaceFetchErrorCard } from "../workspaceRouteChrome";
import { fetchJson } from "../api";

export const HealthRoute = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<HealthData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    document.title = t("meta.healthTitle", { appName: t("common.appName") });
  }, [t]);

  useEffect(() => {
    setError(null);
    fetchJson<HealthData>("/api/ui/health-page")
      .then(setData)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : t("common.fetchFailed")));
  }, [t, refresh]);

  if (error === "Forbidden") {
    return <WorkspaceAdminAccessDenied />;
  }
  if (error) {
    return <WorkspaceFetchErrorCard error={error} onRetry={() => setRefresh((n) => n + 1)} />;
  }
  if (!data) {
    return <div className="text-muted-foreground p-6">{t("common.loading")}</div>;
  }
  return <HealthPage data={data} />;
};
